import { useDispatch } from "react-redux";
import type { AppDispatch } from "../store/rootStore";

export const useAppDispatch = () => useDispatch<AppDispatch>();